export function isKeycodeExpired(keycodeExpirationDate: string): boolean {
  return new Date(keycodeExpirationDate) < new Date();
}
